/* eslint-enable import/no-webpack-loader-syntax */
import OfficeEvents from './office_events'
import initPresentationMonitor from './presentation_monitor'
import constructActivity from '../../../util/construct_activity'
import ErrorModel from '../../../models/error'
import Group from '@polleverywhere/core/lib/models/group'

export default (state) => {
  if (!window.Office) { return }
  window.Office.initialize = async (reason) => {
    // Bind to the MS Office context so that we can get events for everything
    // that happens in MS Office.
    console.log('creating office events')
    const reactor = new OfficeEvents(window.Office, reason)
    console.log('creating office model')
    const officeModel = reactor.model

    state.officeModel = officeModel

    if (officeModel.has('url')) {
      const url = officeModel.get('url')
      const re = new RegExp('([a-z_]+)/([A-Za-z0-9]+)')
      const [, type, permalink] = re.exec(url)
      const activity = await constructActivity(type, permalink)
      let group
      // start loading
      const groups = state.get('user').groups

      // Not found
      if (activity instanceof ErrorModel) {
        const topLevelGroup = groups.get(-1)
        state.appStates.activities.changePage('group', {
          activity: activity,
          group: topLevelGroup
        })

        return
      }

      // Add the group only if we own the activity
      if (activity?.presenter?.id === state.get('user').id) {
        const groupId = activity.get('group_id') || -1

        // get or create the group
        group = groups.add({ id: groupId, owner_id: state.get('user').id })

        // remove the existing activity from the collection if it exists.
        // the ungrouped group is loaded async first so it might already contain is lightweight
        // version of this activity. we remove it instead of merging because the keys of
        // the activity have already been modified by the presenter instance and access to
        // the original json is almost impossible and error prone.
        group.activities.remove(activity)
        group.activities.add(activity)

        // fetch group if it hasn't been fetched yet
        if (!group.activities._lastAjax) {
          state.appStates.activities.fetchGroupActivities(group)
        }
      } else {
        // You don't own this poll so put it in a dummy group
        group = new Group({ id: -2, name: 'My activities' })
      }

      state.appStates.activities.changePage('group', {
        activity: activity,
        group
      })

      if (officeModel.isPresenting()) {
        console.log('initialized within presentation')
        state.changePage('presenter')
      } else {
        console.log('initialized outside of presentation')
        state.changePage('activities')
      }
    }

    officeModel.on('change:activeView', function (activeView) {
      if (officeModel.isPresenting()) {
        console.log('[OFFICE_EVENT] presenting')
        state.changePage('presenter')
      } else {
        console.log('[OFFICE_EVENT] editing')
        state.changePage('activities')
      }
    })

    officeModel.on('change:visibility', function () {
      const isVisible = officeModel.isVisible()
      console.log(`[OFFICE_EVENT] office:change:visibility ${isVisible}`)
      state.set('slideVisible', isVisible)
    })

    initPresentationMonitor(officeModel)
  }
}
